<template>
  <div class="editform">
    <Form ref="feeInfo" :model="feeInfo" :label-width="90">
      <Row>
        <FormPartition title="工单费用">
          <Table
            ref="orderFee"
            :columns="orderFeeColumns"
            :data="feeInfo.orderFeeList"
            :loading="loading"
            :height="150"
          ></Table>
        </FormPartition>
        <div>
          <span>合计：</span><span>{{ orderFeeTotal }}</span>
        </div>
        <FormPartition title="服务费用">
          <Table
            ref="serviceFee"
            :columns="serviceFeeColumns"
            :data="feeInfo.serviceFeeList"
            :loading="loading"
            :height="150"
          ></Table>
        </FormPartition>
        <div>
          <span>合计：</span><span>{{ serviceFeeTotal }}</span>
        </div>
      </Row>
    </Form>
  </div>
</template>

<script>
import Dict from '_u/dict'
import mList from '_v/common/m-list'
import { ymdL } from '_u/helper'
import { isEmpty } from '_u/helper'

export default {
  name: 'orderFee',
  mixins: [mList],
  props: {
    id: {
      type: [String],
      default: '',
    },
    workOrderEntity:{
      type:[Object],
      default:() =>{},
    }
  },
  methods: {

    //渲染列表数据
    loadFeeList(){
      var baseFeeList = this.workOrderEntity.feeList

      //工单费用
      var orderFeeArray = ['cusFuWu']
      //服务费用
      var serviceFeeArray = ['dingJin','fuwu']

      //按照费用类型区分是工单费用还是服务服务
      baseFeeList.forEach((fee) =>{
        fee.woFeeTypeText = this.dict.feeType.get(fee.woFeeType).text
        if (!isEmpty(fee.payType)) {
          fee.payTypeText = this.dict.payType.get(fee.payType).text
        }else {
          fee.payTypeText = '微信支付';
        }
        fee.payStatusText = this.dict.payStatus.get(fee.payStatus).text
        fee.createTimeText = ymdL(fee.createTime)
        fee.amount = fee.amount/100//单位转换为元

        if (orderFeeArray.indexOf(fee.woFeeType) != -1){
          this.feeInfo.orderFeeList.push(fee)
        }
        if (serviceFeeArray.indexOf(fee.woFeeType) != -1){
          this.feeInfo.serviceFeeList.push(fee)
        }
      })
    },

    countAmount(list) {
      var resultAmount = 0

      list.forEach((v) => {
        resultAmount = resultAmount + v.amount
      })

      return resultAmount
    },
  },

  created() {
    this.loading = true
    Promise.all([
      Dict.get('wo_pay_status'),
      Dict.get('pay_type'),
      Dict.get('wo_fee_type'),
    ])
      .then((args) => {
        var [payStatus, payType, feeType] = args
        this.dict.payStatus = payStatus
        this.dict.payType = payType
        this.dict.feeType = feeType
        //渲染列表数据
        this.loadFeeList()

        //统计项计算
        this.serviceFeeTotal = this.countAmount(
          this.feeInfo.serviceFeeList
        )
        this.orderFeeTotal = this.countAmount(
          this.feeInfo.orderFeeList
        )
      })
      .finally((this.loading = false))
  },
  data() {
    return {
      mtHeight: 360,
      loading: false,
      feeInfo: {
        orderFeeList: [],
        serviceFeeList: [],
      },
      orderFeeTotal: '',
      serviceFeeTotal: '',
      dict:{
        feeType:Dict.NULL,
        payType:Dict.NULL,
        payStatus:Dict.NULL,
      }
    }
  },
  computed: {
    orderFeeColumns() {
      return [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          width: 60,
        },
        {
          key: 'woFeeTypeText',
          title: '费用类型',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'amount',
          title: '费用金额（元）',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'remark',
          title: '备注说明',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'payTypeText',
          title: '支付方式',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'payStatusText',
          title: '费用状态',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'createTimeText',
          title: '发生时间',
          align: 'center',
          minWidth: 60,
        },
      ]
    },
    serviceFeeColumns() {
      return [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          width: 60,
        },
        {
          key: 'woFeeTypeText',
          title: '费用类型',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'amount',
          title: '费用金额（元）',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'remark',
          title: '备注说明',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'payTypeText',
          title: '支付方式',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'payStatusText',
          title: '费用状态',
          align: 'center',
          minWidth: 60,
        },
        {
          key: 'createTimeText',
          title: '发生时间',
          align: 'center',
          minWidth: 60,
        },
      ]
    },
  },
}
</script>
